import { Injectable } from '@angular/core';
import { ColInfo, SortingState } from '../data-models/table.typings';
import { RecordingCl } from '../data-models/recording.typings';
import { isString, isNumber } from 'util';

@Injectable()
export class SortingService {
   constructor(
   ) {
   }

   increasing(recordings: RecordingCl[], field: string, reSortCount = 0): RecordingCl[] {
      const snapshot = this.sequenceSnap(recordings);

      let sorted: RecordingCl[] = recordings.sort((curr, next) => {
         let resp: number;
         const a = curr.appInfo.sortInfo[field];
         const b = next.appInfo.sortInfo[field];
         if (isString(a) && isString(b)) {
            resp = a.localeCompare(b);
         } else if (isNumber(a) && isNumber(b)) {
            resp = a - b;
         } else {
            resp = 0;
            console.error('Bad sorting params: ', field, a, b);
         }

         return resp;
      });

      if (snapshot === this.sequenceSnap(sorted) && reSortCount < 1) {
         sorted = this.decreasing(recordings, field, 1);
      }

      return sorted;
   }


   decreasing(recordings: RecordingCl[], field: string, reSortCount = 0): RecordingCl[] {
      const snapshot = this.sequenceSnap(recordings);

      let sorted: RecordingCl[] = recordings.sort((curr, next) => {
         let resp: number;
         const a = curr.appInfo.sortInfo[field];
         const b = next.appInfo.sortInfo[field];
         if (isString(a) && isString(b)) {
            resp = b.localeCompare(a);
         } else if (isNumber(a) && isNumber(b)) {
            resp = b - a;
         } else {
            resp = 0;
            console.error('Bad sorting params: ', field, a, b);
         }

         return resp;
      });

      if (snapshot === this.sequenceSnap(sorted) && reSortCount < 1) {
         sorted = this.decreasing(recordings, field, 1);
      }

      return sorted;
   }


   sequenceSnap(recordings: RecordingCl[]): string {
      let snapshot = '';

      recordings.forEach(recording => {
         snapshot += recording.title;
      });

      return snapshot;
   }
}



// WEBPACK FOOTER //
// ./src/app/services/sorting.service.ts